import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import Breadcrumbs from '../components/Breadcrumbs';
import { PAGE_SEO, BLOG_POSTS } from '../utils/seoConstants';

/**
 * Blog Index Page
 * Lists all blog articles for SEO and GEO optimization
 */
const Blog = () => {
  return (
    <>
      <SEOHead
        title={PAGE_SEO.blog.title}
        description={PAGE_SEO.blog.description}
        canonicalUrl="/blog"
      />

      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <header className="bg-gradient-to-br from-[#0d1b2a] to-[#1b3a5d] text-white py-16">
          <div className="max-w-6xl mx-auto px-4">
            <Breadcrumbs
              items={[{ name: 'Blog', href: '/blog' }]}
              className="text-gray-300 mb-6"
            />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Yacht Crew Blog
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl">
              Career tips, industry news, salary guides, and certification information.
              Everything you need for a successful career in yachting.
            </p>
          </div>
        </header>

        {/* Definition Lead for GEO */}
        <section className="max-w-6xl mx-auto px-4 py-8">
          <p className="text-lg text-gray-700 max-w-3xl">
            The 1crew3 yacht crew blog provides comprehensive guides, industry insights,
            and career advice for yacht crew members and captains. From salary guides and
            certification requirements to interview tips and regional job market updates,
            our articles help you navigate the yacht industry.
          </p>
        </section>

        {/* Blog Grid */}
        <main className="max-w-6xl mx-auto px-4 pb-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {BLOG_POSTS.map((post) => (
              <article
                key={post.slug}
                className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden"
              >
                <div className="h-40 bg-gradient-to-br from-blue-500 to-cyan-400" />
                <div className="p-6">
                  <h2 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="hover:text-blue-600 transition-colors"
                    >
                      {post.title}
                    </Link>
                  </h2>
                  <p className="text-gray-600 text-sm line-clamp-3">
                    {post.description}
                  </p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="inline-block mt-4 text-blue-600 font-medium text-sm hover:text-blue-700"
                  >
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </main>

        {/* CTA Section */}
        <section className="bg-[#0d1b2a] text-white py-16">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              Ready to Start Your Yachting Career?
            </h2>
            <p className="text-gray-300 mb-8">
              Join 1crew3 today — free for crew members forever.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/register"
                className="px-8 py-3 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg transition-colors"
              >
                Sign Up Free
              </Link>
              <Link
                to="/jobs"
                className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-colors"
              >
                Browse Jobs
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-gray-400 py-8">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <Link to="/" className="text-white font-bold text-lg">
              1crew3
            </Link>
            <p className="mt-2 text-sm">
              Connect. Match. Work.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Blog;
